import React, { useRef, useEffect } from "react";

export default function Spinner({
  waitfor,
  children,
  className,
  style = {},
  spin,
  spinhideinnerhtml,
  parentRef,
  color = "#000",
}) {
  const opts = {
    lines: 12, // The number of lines to draw
    length: 5, // The length of each line
    width: 2, // The line thickness
    radius: 5, // The radius of the inner circle
    scale: 1, // Scales overall size of the spinner
    corners: 1, // Corner roundness (0..1)
    color: color, // #rgb or #rrggbb or array of colors
    opacity: 0.25, // Opacity of the lines
    rotate: 0, // The rotation offset
    direction: 1, // 1: clockwise, -1: counterclockwise
    speed: 1, // Rounds per second
    trail: 60, // Afterglow percentage
    fps: 20, // Frames per second when using setTimeout() as a fallback for CSS
    zIndex: 2e9, // The z-index (defaults to 2000000000)
    className: "spinner", // The CSS class to assign to the spinner
    top: "50%", // Top position relative to parent
    left: "50%", // Left position relative to parent
    shadow: false, // Whether to render a shadow
    hwaccel: false, // Whether to use hardware acceleration
    position: "absolute", // Element positioning
  };
  const obj = new window.Spinner(opts);
  const spinnerRef = useRef(obj);
  const elemRef = useRef();

  function hideText(elem, originalText) {
    elem.html('<span style="visibility:hidden">' + originalText + "</span>");
  }

  function restoreText(elem, originalText) {
    elem.html(originalText);
  }

  useEffect(() => {
    if (spin != null) {
      const originalText = parentRef.current.innerHTML;
      const spinner = spinnerRef.current;
      if (spin === true) {
        if (spinhideinnerhtml) {
          hideText(parentRef.current, originalText);
        }
        spinner.spin(parentRef.current);
        parentRef.current.disabled = true;
      }
      if (spin === false) {
        if (spinhideinnerhtml) {
          restoreText(parentRef.current, originalText);
        }
        spinner.stop();
        parentRef.current.disabled = false;
      }
    }
  }, [parentRef, spin, spinhideinnerhtml]);

  useEffect(() => {
    if (spin == null && !waitfor) {
      const spinner = spinnerRef.current;
      spinner.spin(elemRef.current);
      return () => {
        spinner.stop();
      };
    }
  }, [waitfor, spin]);
  return (
    <i
      className={className}
      ref={(ref) => (elemRef.current = ref)}
      style={style}
    >
      {children}
    </i>
  );
}
